'use client'

import { getClassNames } from '@helpers/productWidgetHelper'

export type AbhaHeroModalCloseButtonProps = {
  onClick: () => void
  size?: 'md' | 'lg'
  className?: string
}

const CLOSE_ICON_SIZE = {
  md: 24,
  lg: 32,
} as const

export const AbhaHeroModalCloseButton = ({ onClick, size = 'md', className }: AbhaHeroModalCloseButtonProps) => {
  const iconSize = CLOSE_ICON_SIZE[size]

  return (
    <button
      type="button"
      className={getClassNames(['acko-dialog-close', 'abha-hero-modal__close', className ?? ''], {
        'abha-hero-modal__close--lg': size === 'lg',
      })}
      aria-label="Close dialog"
      onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={iconSize}
        height={iconSize}
        viewBox="0 0 24 24"
        fill="currentColor"
        className="abha-hero-modal__close-icon">
        <path
          d="M18.47 6.59C18.7627 6.29729 18.7627 5.82271 18.47 5.53C18.1773 5.23729 17.7027 5.23729 17.41 5.53L12 10.94L6.59 5.53C6.29729 5.23729 5.82271 5.23729 5.53 5.53C5.23729 5.82271 5.23729 6.29729 5.53 6.59L10.94 12L5.53 17.41C5.23729 17.7027 5.23729 18.1773 5.53 18.47C5.82271 18.7627 6.29729 18.7627 6.59 18.47L12 13.06L17.41 18.47C17.7027 18.7627 18.1773 18.7627 18.47 18.47C18.7627 18.1773 18.7627 17.7027 18.47 17.41L13.06 12L18.47 6.59Z"
          fill="#141414"
        />
      </svg>
    </button>
  )
}
